import React from 'react';

const EarthquakeDetails = ({ earthquake }) => {
  //earthquake.properties.time is the timestamp in milliseconds since 1 january 1970
  const timestamp = earthquake.properties.time;
  const formattedTime = new Date(timestamp).toLocaleString('pt-PT', {
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

  return (
    <div>
        <p>{earthquake.properties.title}</p>
        <p>Magnitude: {earthquake.properties.mag}</p>
        <p>Latitude: {earthquake.geometry.coordinates[1].toFixed(1)} ºN</p>
        <p>Longitude: {earthquake.geometry.coordinates[0].toFixed(1)} ºE</p>
        <p>Depth: {earthquake.geometry.coordinates[2]} km</p>
        <p>Time: {formattedTime}</p>
    </div>
  );
};

export default EarthquakeDetails;
